import Image from './component.jsx'
export default Image
